import React from "react";
import { Grid, Typography, FormControlLabel, Checkbox, TextField } from "@mui/material";

const LanguageCheckboxGroup = ({ label, category, formData, handleChange }) => {
  const handleCheckboxChange = (language) => (event) => {
    const isChecked = event.target.checked;
    handleChange(category, language, isChecked);
  };

  const handleTextFieldChange = (event) => {
    const value = event.target.value;
    handleChange(category, 'otherLanguage', value);
  };

  return (
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom>
        {label}
      </Typography>
      <Grid container spacing={2}>
        {Object.keys(formData[category]).map((language) => (
          language !== 'otherLanguage' && (
            <Grid item xs={12} sm={6} md={4} key={language}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData[category][language]}
                    onChange={handleCheckboxChange(language)}
                    name={language}
                  />
                }
                label={language.charAt(0).toUpperCase() + language.slice(1)} 
                sx={{ '.MuiFormControlLabel-label': { color: 'grey' } }}
              />
            </Grid>
          )
        ))}
        {formData[category].other && (
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              label="Please specify"
              name="otherLanguage"
              value={formData[category].otherLanguage}
              onChange={handleTextFieldChange}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default LanguageCheckboxGroup;
